import { IDAO } from 'api/communitiesApi';

export default function CommunityToken({ dao }: { dao: IDAO }): JSX.Element {
  return (
    <div style={{ color: '#f9f9f9', marginTop: '40px' }}>
      {dao && 'Coming soon...'}
    </div>
  );
}
